import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { Registration } from '@/types/registration.types';
import Container from '@ui/container/container';
import SwitchV2 from '@ui/switch-v2/switch-v2';
import Text from '@ui/text/text/text';
import useComputedRegistrationSettings from '../../hooks/use-computed-registration-settings';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';

export default function SingleUseRegistrationToggle() {
  const dispatch = useAppDispatch();
  const { courseOn, registrationSettings } = useComputedRegistrationSettings();
  const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);

  const linkLimit = registrationSettings?.emailLinkLimit;
  const confirmationRequired = registrationSettings?.registrationConfirmation;

  const toggleEmailLinkLimit = (value: number | null, on: boolean) => {
    if (!registrationSettings) return;
    const updatedSettings: Registration = {
      ...registrationSettings,
      emailLinkLimit: on ? 1 : null,
    };

    dispatch(saveWorkingProjectByFields({ registration_settings: updatedSettings }));
  };

  return (
    <Container design="GlobalCont1" borderRadius="12px" padding="16px" className="flex ai-center jc-space-between">
      <div className="flex ai-center gap-8">
        <Text tag="h6" className="H6">
          Single use registrations
        </Text>
        <TooltipPortal
          tooltipContent={
            <Text>
              This setting applies to all registered emails, including those that have already have been sent. To
              enable, require confirmation must be enabled.
            </Text>
          }
        >
          <Icon name={ICONS.INFO_CIRCLE} size={12} color="var(--primitives-mode-1-gray-500)" />
        </TooltipPortal>
      </div>
      <div>
        <SwitchV2
          loading={!registrationSettings || savingWorkingProject}
          value={linkLimit ?? null}
          on={courseOn ? false : !!linkLimit}
          onClick={toggleEmailLinkLimit}
          disabled={courseOn || !confirmationRequired}
        />
      </div>
    </Container>
  );
}
